import React from 'react';
import { SearchConditionLabelResponse } from '@doda/api-client/aspida/@types';
import { CommonSimpleBar } from 'components/CommonSimpleBar';
import styles from './index.module.scss';
import { CONDITION_MAP } from './constants';

/**
 * 現在の検索条件モーダルのボディ条件rops
 */
interface Props {
  /** 現在の検索条件データ */
  currentConditionData: SearchConditionLabelResponse;
}

/**
 * 現在の検索条件モーダルのボディ条件を表示するコンポーネント
 * @param {Props} props - コンポーネントに渡されるプロパティ
 * @returns {JSX.Element} 現在の検索条件モーダルのボディ条件を表示する要素
 */
export const CurrentConditionModalBodyConditions: React.FC<Props> = ({
  currentConditionData,
}) => {
  const {
    transitionUrl,
    summary,
    includedKeyword,
    excludedKeyword,
    detail,
    ...rest
  } = currentConditionData;

  /** キーワード条件が存在するかを示すフラグ */
  const isKeywordCondition = includedKeyword || excludedKeyword;

  // 何も条件が存在しない場合
  if (
    Object.values({
      includedKeyword,
      excludedKeyword,
      ...detail,
      ...rest,
    }).filter(Boolean).length === 0
  ) {
    return (
      <div className={styles.currentConditionModalBody__conditions}>
        指定なし
      </div>
    );
  }

  return (
    <>
      <div className={styles.currentConditionModalBody__conditions}>
        <CommonSimpleBar>
          {/* 条件 */}
          {Object.entries(rest).map(
            ([key, value]) =>
              value && (
                <dl
                  key={key}
                  className={styles.currentConditionModalBody__conditionsList}
                >
                  <dt
                    className={
                      styles.currentConditionModalBody__conditionsListTitle
                    }
                  >
                    {CONDITION_MAP[key as keyof typeof CONDITION_MAP]}
                  </dt>
                  <dd
                    className={
                      styles.currentConditionModalBody__conditionsListData
                    }
                  >
                    {value}
                  </dd>
                </dl>
              )
          )}

          {/* キーワード */}
          {isKeywordCondition && (
            <dl className={styles.currentConditionModalBody__conditionsList}>
              <dt
                className={
                  styles.currentConditionModalBody__conditionsListTitle
                }
              >
                キーワード
              </dt>
              <dd
                className={styles.currentConditionModalBody__conditionsListData}
              >
                <dl>
                  {includedKeyword && (
                    <dd
                      className={
                        styles.currentConditionModalBody__conditionsKeyword
                      }
                    >
                      {includedKeyword}
                    </dd>
                  )}
                  {excludedKeyword && (
                    <dd
                      className={
                        styles.currentConditionModalBody__conditionsKeyword
                      }
                    >
                      {excludedKeyword}
                    </dd>
                  )}
                </dl>
              </dd>
            </dl>
          )}

          {/* 詳細条件(detail) */}
          {detail && (
            <dl className={styles.currentConditionModalBody__conditionsList}>
              <dt
                className={
                  styles.currentConditionModalBody__conditionsListTitle
                }
              >
                詳細条件
              </dt>
              <dd
                className={styles.currentConditionModalBody__detailConditions}
              >
                {Object.entries(detail).map(
                  ([key, value]) =>
                    value && (
                      <dl
                        className={
                          styles.currentConditionModalBody__detailConditionsList
                        }
                        key={key}
                      >
                        <dt
                          className={
                            styles.currentConditionModalBody__detailConditionsTitle
                          }
                        >
                          {CONDITION_MAP[key as keyof typeof CONDITION_MAP]}
                        </dt>
                        <dd
                          className={
                            styles.currentConditionModalBody__detailConditionsData
                          }
                        >
                          {value}
                        </dd>
                      </dl>
                    )
                )}
              </dd>
            </dl>
          )}
        </CommonSimpleBar>
      </div>
    </>
  );
};
